import {PayloadAction} from "@reduxjs/toolkit";
import {put, call} from 'redux-saga/effects';
import {cardEditorActions} from "../cardEditor.slice";
import {api} from "../../../api/api";
import {cardsActions} from "../../cards.slice";
import {CardDto} from "../../../common";

export function* loadEditorSaga(action: PayloadAction<string>) {
    yield put(cardEditorActions.setMarkup(''));
    yield put(cardEditorActions.setCardId(action.payload));

    const card: CardDto = yield call(api.loadCard, action.payload);
    yield put(cardsActions.put([card]));
    yield put(cardEditorActions.setMarkup(card.markup));
}
